import Vue from 'vue'
import App from './App.vue'
import i18n from '@/plugins/i18n'
import vuetify from './plugins/vuetify'
import router from '@/routers'
import Private from '@/layouts/private/Index.vue'
import Public from '@/layouts/public/Index.vue'
import store from '@/store'
import { sync } from 'vuex-router-sync'
import utils from '@/services/utils'

import VImageInput from 'vuetify-image-input'

import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import { VTextField } from 'vuetify/lib'
Vue.component('v-text-field', VTextField)
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyDLr_PUL0bfUlamQkilrlnzuR0XEmbcdfg'
  // apiKey: 'AIzaSyB5OyDZ-sXTNgU7HXDE3KdOIBhpahh0ljs'
})

import VueSessionStorage from 'vue-sessionstorage'
Vue.use(VueSessionStorage)


Vue.component('private-layout', Private)
Vue.component('public-layout', Public)

Vue.component(VImageInput.name, VImageInput)

sync(store, router)

Vue.config.productionTip = false

if (utils.getDomain().indexOf('radissonbluemogan') >= 0) {
  window.location.href = window.location.href.replace('radissonbluemogan', 'radissonblumogan')
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') == null || localStorage.getItem('jwt').length == 0) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    if (utils.isTotem() && to.path !== '/totem') {
      next({
        path: '/totem',
        params: { fullScreen: true }
      })
    } else next()
  }
})

new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
